import type { CSSProperties } from 'react';
import type { AppConfig } from '../types/config.types';

/** Default TextArea limit when Cementos LEGACY multi-step is off. */
export const DEFAULT_COMMITTEE_COMMENT_MAX_LENGTH = 120;

/** Extended limit for Cementos LEGACY comité (multi-step approval flow). */
export const EXTENDED_COMMITTEE_COMMENT_MAX_LENGTH = 1000;

export type CommitteeCommentConfig = Pick<
  AppConfig,
  'isMultipleApprovalInCommitteeEnabled' | 'isCommitteeMemberQuorumEnabled'
>;


export function isCementosLegacyCommittee(config: CommitteeCommentConfig): boolean {
  return (
    config.isMultipleApprovalInCommitteeEnabled === true &&
    config.isCommitteeMemberQuorumEnabled !== true
  );
}

export function getCommitteeCommentMaxLength(config: CommitteeCommentConfig): number {
  return isCementosLegacyCommittee(config)
    ? EXTENDED_COMMITTEE_COMMENT_MAX_LENGTH
    : DEFAULT_COMMITTEE_COMMENT_MAX_LENGTH;
}

export const committeeCommentWrapStyle: CSSProperties = {
  whiteSpace: 'normal',
  wordBreak: 'break-word',
  overflowWrap: 'break-word',
};
